import axios from "axios";
import { storeTokens, clearTokens } from "$api/tokenManagement";

export async function login(values) {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  let form_data = new URLSearchParams();
  form_data.append("username", values.username);
  form_data.append("password", values.password);

  const response = await axios.post(
    `${process.env.REACT_APP_CALENDER_API}/auth/login`,
    form_data,
    { headers: myHeaders }
  );

  storeTokens(response.data.access_token);

  return response.data;
}

export function logout() {
  clearTokens();
}
